module.exports = __webpack_public_path__ + "media/svgs/studio-map-marker-3e1dfa18936d06effe9eefeabd259da5.svg";